import { j as c } from "../../../jsx-runtime-B6kdoens.js";
import { a as m } from "../../../index-CROKJrb5.js";
import { c as n, f as p } from "../../../create-component-CBAeEoQ6.js";
const u = n(
  "FooterBody",
  p(
    ({ as: o, children: r, className: t, ...e }, s) => {
      const a = o || "section";
      return /* @__PURE__ */ c.jsx(
        a,
        {
          ref: s,
          className: m("cur-flex cur-flex-wrap cur-gap-10", t),
          ...e,
          children: r
        }
      );
    }
  )
);
export {
  u as FooterBody
};
//# sourceMappingURL=index.js.map
